import { Controller } from "remult";

@Controller("organization-manager-methods")
export class OrganizationManagerMethods {}
